import { inject, Injectable, Signal, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SOFTLINE_MASTER_DETAIL_HEIGHT } from '@softline/ui-core';
import { debounceTime, ReplaySubject } from 'rxjs';

export interface ShellAppearanceConfig {
  titleBar?:
    | boolean
    | {
        displayUsername: boolean | string | Signal<string>;
        displayDateTime: boolean | 'date' | 'datetime' | 'time';
      };
}

@Injectable({ providedIn: 'root' })
export class ShellService {
  readonly #masterDetailHeight = inject(SOFTLINE_MASTER_DETAIL_HEIGHT, {
    optional: true,
  });

  readonly #appearance = signal<ShellAppearanceConfig | undefined>(undefined);
  readonly #contentRect = new ReplaySubject<DOMRect>(1);

  readonly appearance = this.#appearance.asReadonly();
  readonly contentRect$ = this.#contentRect.asObservable();

  constructor() {
    this.contentRect$.pipe(takeUntilDestroyed(), debounceTime(10)).subscribe((rect) => {
      this.#masterDetailHeight?.set(rect.height);
    });
  }

  setAppearance(config: ShellAppearanceConfig | undefined): void {
    this.#appearance.set(config);
  }

  setContentRect(value: DOMRect): void {
    this.#contentRect.next(value);
  }
}
